module.exports = __webpack_public_path__ + "media/images/registrations/info_version/info-4-638ac95d5fef7a5eb0ca36bd95c44c03.png";